import React from 'react';

const layout = (props) => {
  return(
    <div>
      {props.children}
    </div>
  )
}

export default layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js